import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import React from "react";
import AddCareTeamComp from "components/add-care-team/AddCareTeamComp";
import UserAuth from "components/AuthGaurd/UserAuth";
type Props = {};

export default function AddCareTeam({}: Props) {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <section id="hero">
        <div className="tw-w-full tw-bg-[#F7F7F7]">
          {/* first Item */}
          <div className="tw-flex tw-py-4 sm:tw-py-6 tw-pl-10  sm:tw-pl-12 md:tw-pl-14 tw-bg-[#F7F7F7] tw-items-center">
            <p className="tw-text-[24px] md:tw-text-[26px] lg:tw-text-[32px] tw-text-black tw-font-bold">
              {window.location.pathname === "/user/care-team/add-care-team/add" || window.location.pathname === "/user/care-team/add-care-team/add/activate"
                ? "Add Care Team"
                : "Edit Care Team"}
            </p>
          </div>
          {/* second Item */}

          <div className=" tw-top-[9.375rem] tw-w-full tw-flex tw-flex-col tw-pt-8 lg:tw-pb-36 tw-rounded-t-[2rem] tw-shadow-inner tw-relative">
            <div
              className="tw-absolute tw-inset-0 tw-bg-[url('/src/assets/images/section-bg.svg')] tw-bg-center tw-bg-no-repeat tw-bg-cover"
              style={{ mixBlendMode: "luminosity" }}
            ></div>
            {/* Rest of your content */}
            <div className="tw-flex tw-flex-col tw-gap-8">
              <AddCareTeamComp />
            </div>
          </div>
        </div>
      </section>
      <footer className="tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
}
